import { FileText } from "lucide-react";

export function PlanDiffSummary({ diff }: { diff: Record<string, unknown> }) {
	const before = diff.before as Record<string, unknown> | undefined;
	const after = diff.after as Record<string, unknown> | undefined;
	const reason = typeof diff.reason === "string" ? diff.reason : null;
	const count = (value: unknown) =>
		typeof value === "number" ? value : typeof value === "string" ? value : "-";
	const objects = (value: unknown) =>
		Array.isArray(value) && value.length > 0 ? value.join(", ") : "none listed";

	return (
		<div className="mb-2 rounded border border-border/70 bg-muted/20 p-2 text-[11px]">
			<div className="mb-1 flex items-center gap-1 font-semibold text-foreground/80">
				<FileText className="h-3 w-3" />
				Plan edit
			</div>
			{reason && <p className="mb-1 text-muted-foreground">{reason}</p>}
			<div className="grid grid-cols-2 gap-2 text-muted-foreground">
				<PlanDiffSide title="Before" steps={before} count={count} objects={objects} />
				<PlanDiffSide title="After" steps={after} count={count} objects={objects} />
			</div>
		</div>
	);
}

function PlanDiffSide({
	title,
	steps,
	count,
	objects,
}: {
	title: string;
	steps: Record<string, unknown> | undefined;
	count: (value: unknown) => string | number;
	objects: (value: unknown) => string;
}) {
	const objectList = objects(steps?.objects);
	return (
		<div className="rounded bg-card/60 p-1.5">
			<div className="font-mono text-[11px] text-foreground/70">{title}</div>
			<div>setup {count(steps?.setup_count)}</div>
			<div>steps {count(steps?.step_count)}</div>
			<div className="truncate" title={objectList}>
				objects {objectList}
			</div>
		</div>
	);
}
